import styled from "@emotion/styled";

export const Container = styled.div``;

export const StyledMessage = styled.span`
  color: #666666;
`;

export const StyledHeadline = styled.span`
  color: #666666;
  font-weight: 700;
`;
